// components/InscriptionWp.jsx
// Formulaire d'inscription via WordPress (réglage WP_INSCRIPTION_ACTIVE côté serveur) : anti-robot Turnstile,
// puis message TOUJOURS identique « vérifiez votre boîte mail », que l'adresse existe déjà ou non.

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BookOpen } from 'lucide-react';
import Turnstile from './Turnstile';
import { envoyerAuth, langueInterface, messageErreurOubli, LONGUEUR_MIN_MOT_DE_PASSE } from '../utils/authOubli';
import '../pages/AuthPages.css';
import ChampMotDePasse from './ChampMotDePasse';

export default function InscriptionWp({ turnstileSiteKey }) {
  const { t, i18n } = useTranslation();
  const [champs, setChamps] = useState({ prenom: '', email: '', motDePasse: '', confirmation: '' });
  const [jetonTurnstile, setJetonTurnstile] = useState('');
  const [reinitTurnstile, setReinitTurnstile] = useState(0);
  const [erreur, setErreur] = useState('');
  const [termine, setTermine] = useState(false);
  const [enCours, setEnCours] = useState(false);
  const saisir = (nom) => (e) => setChamps((c) => ({ ...c, [nom]: e.target.value }));

  const messageSpecifique = (code) => ({
    ANTI_ROBOT_ECHEC: t('auth.antiRobotEchec'),
    INSCRIPTION_INDISPONIBLE: t('auth.inscriptionIndisponible'),
    DONNEES_INVALIDES: t('auth.donneesInvalides'),
  })[code] || messageErreurOubli(t, code);

  const soumettre = async (e) => {
    e.preventDefault();
    setErreur('');
    if (Array.from(champs.motDePasse).length < LONGUEUR_MIN_MOT_DE_PASSE) return setErreur(t('auth.mdpTropCourt', { min: LONGUEUR_MIN_MOT_DE_PASSE }));
    if (champs.motDePasse !== champs.confirmation) return setErreur(t('auth.mdpNeCorrespondentPas'));
    setEnCours(true);
    const rep = await envoyerAuth('/api/auth/inscription', {
      prenom: champs.prenom, email: champs.email, motDePasse: champs.motDePasse,
      langue: langueInterface(i18n), jetonTurnstile,
    });
    setEnCours(false);
    if (rep.ok) return setTermine(true);
    setErreur(messageSpecifique(rep.code));
    setJetonTurnstile('');
    setReinitTurnstile((n) => n + 1); // un jeton Turnstile ne sert qu'une fois
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <BookOpen size={40} color="#4F46E5" />
          <h1>VocaVerb</h1>
          <p>{t('auth.registerSubtitle')}</p>
        </div>

        {erreur && <div className="auth-error">{erreur}</div>}

        {termine ? (
          <div className="auth-success">{t('auth.inscriptionEnvoyee')}</div>
        ) : (
          <form onSubmit={soumettre} className="auth-form">
            <div className="form-group">
              <label htmlFor="prenom">{t('auth.prenom')} *</label>
              <input id="prenom" type="text" value={champs.prenom} onChange={saisir('prenom')} placeholder={t('auth.prenom')} required maxLength={100} autoComplete="given-name" />
            </div>
            <div className="form-group">
              <label htmlFor="email">{t('auth.emailRequired')}</label>
              <input id="email" type="email" value={champs.email} onChange={saisir('email')} placeholder={t('auth.emailPlaceholder')} required autoComplete="email" />
            </div>
            <div className="form-group">
              <label htmlFor="password">{t('auth.passwordRequired')}</label>
              <ChampMotDePasse id="password" value={champs.motDePasse} onChange={saisir('motDePasse')} placeholder={t('auth.passwordPlaceholderMin', { min: LONGUEUR_MIN_MOT_DE_PASSE })} required autoComplete="new-password" />
            </div>
            <div className="form-group">
              <label htmlFor="confirmPassword">{t('auth.confirmPassword')}</label>
              <ChampMotDePasse id="confirmPassword" value={champs.confirmation} onChange={saisir('confirmation')} placeholder={t('auth.confirmPasswordPlaceholder')} required autoComplete="new-password" />
            </div>

            <Turnstile siteKey={turnstileSiteKey} onToken={setJetonTurnstile} reinitialiser={reinitTurnstile} />

            <button type="submit" className="auth-submit" disabled={enCours || !jetonTurnstile}>
              {enCours ? t('auth.creation') : t('auth.creerCompte')}
            </button>
          </form>
        )}

        <div className="auth-footer">
          <p>{t('auth.dejaUnCompte')} <Link to="/login">{t('auth.seConnecter')}</Link></p>
        </div>
      </div>
    </div>
  );
}
